/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgExtScanSessionResultModel } from '../../models/org-ext-scan-session-result-model';

export interface OrgExtSessionResultOrganizationIdPersonIdSessionIdGet$Params {
  organizationId: string;
  personId: string;
  sessionId: string;
}

export function orgExtSessionResultOrganizationIdPersonIdSessionIdGet(http: HttpClient, rootUrl: string, params: OrgExtSessionResultOrganizationIdPersonIdSessionIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<OrgExtScanSessionResultModel>> {
  const rb = new RequestBuilder(rootUrl, orgExtSessionResultOrganizationIdPersonIdSessionIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('personId', params.personId, {});
    rb.path('sessionId', params.sessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<OrgExtScanSessionResultModel>;
    })
  );
}

orgExtSessionResultOrganizationIdPersonIdSessionIdGet.PATH = '/OrgExt/SessionResult/{organizationId}/{personId}/{sessionId}';
